import { useEffect, useState } from "react";
import { trackSectionCtaClick } from "@/lib/analytics";

const SCORE_FOCUS_STORAGE_KEY = "integrated_social_score_focus_request";

export default function MobileScoreCta() {
  const [visible, setVisible] = useState(false);
  const [isScorePage, setIsScorePage] = useState(false);
  const [isLocalPage, setIsLocalPage] = useState(false);

  useEffect(() => {
    const update = () => {
      setVisible(window.scrollY >= 600);
      setIsScorePage(window.location.pathname === "/free-ai-growth-audit/");
      setIsLocalPage(window.location.pathname === "/local/" || window.location.pathname.startsWith("/local/"));
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("popstate", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("popstate", update);
    };
  }, []);

  return (
    <div className={`${visible && !isScorePage ? "flex" : "hidden"} fixed inset-x-0 bottom-0 z-[90] border-t border-[#FF8C00]/30 bg-[#0F1419]/95 px-3 py-2 shadow-[0_-4px_18px_rgba(0,0,0,0.28)] backdrop-blur md:hidden`}>
      <a
        href={isLocalPage ? "/free-ai-growth-audit/?src=local_sticky" : "/free-ai-growth-audit/"}
        data-score-direct="true"
        onClick={() => {
          try { window.sessionStorage.setItem(SCORE_FOCUS_STORAGE_KEY, "1"); } catch { /* optional browser enhancement */ }
          const destination = isLocalPage ? "/free-ai-growth-audit/?src=local_sticky" : "/free-ai-growth-audit/";
          trackSectionCtaClick({
            section_name: isLocalPage ? "local_sticky" : "mobile_sticky",
            cta_text: isLocalPage ? "Check my AI visibility" : "Check my AI visibility",
            destination,
          });
        }}
        className="flex min-h-12 w-full items-center justify-center rounded-sm bg-[#FF8C00] px-4 py-2.5 text-base font-bold text-[#0F1419] transition-colors active:scale-[0.98]"
      >
        {isLocalPage ? "Check my AI visibility" : "Check my AI visibility"}
      </a>
    </div>
  );
}
